var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import Textarea from '../textarea';
import { Styled } from './style';
var InlineTextArea = /** @class */ (function (_super) {
    __extends(InlineTextArea, _super);
    function InlineTextArea(props) {
        var _this = _super.call(this, props) || this;
        _this.focusAtLastChar = function (event) {
            var value = event.currentTarget.value;
            event.currentTarget.value = '';
            event.currentTarget.value = value;
        };
        _this.enableEditMode = function () {
            _this.setState({ editmode: true });
            if (_this.props.onEdit) {
                _this.props.onEdit();
            }
        };
        _this.disableEditMode = function () {
            _this.setState({ editmode: false });
        };
        _this.handleKeyDown = function (event) {
            var key = event.key;
            var value = event.currentTarget.value;
            if (key === 'Enter') {
                _this.saveValue(event, value);
                _this.disableEditMode();
            }
            else if (key === 'Escape') {
                _this.disableEditMode();
            }
        };
        _this.handleOnChange = function (value) {
            var valueTemp = value;
            if (value.length === 0) {
                valueTemp = _this.state.value ? _this.state.value : '';
            }
            _this.setState({ value: valueTemp });
        };
        _this.saveValue = function (e, value) {
            var valueTemp = value;
            if (_this.props.onSaved) {
                _this.props.onSaved(e, valueTemp);
                _this.setState({ value: valueTemp });
            }
        };
        _this.state = {
            editmode: _this.props.editmode,
            value: _this.props.value,
        };
        return _this;
    }
    InlineTextArea.prototype.render = function () {
        var _this = this;
        var value = this.state.value;
        var placeholder = this.props.placeholder;
        var textLabel = (React.createElement("span", { className: "title", onClick: this.enableEditMode }, value));
        if (this.props.disabled) {
            return textLabel;
        }
        var textInput = (React.createElement(Textarea, { autoFocus: true, rows: 1, maxLength: this.props.maxLength, defaultValue: value, placeholder: placeholder, onKeyDown: this.handleKeyDown, onChange: function (event) {
                _this.handleOnChange(event.currentTarget.value);
            }, onBlur: function (event) {
                _this.saveValue(event, _this.state.value);
                _this.disableEditMode();
            }, spellCheck: this.props.spellCheck || false }));
        return (React.createElement(Styled, { className: "edit-" + this.state.editmode },
            this.state.editmode ? null : textLabel,
            this.state.editmode ? textInput : null));
    };
    InlineTextArea.defaultProps = {
        value: '',
        placeholder: '',
        editmode: false,
    };
    return InlineTextArea;
}(React.Component));
export { InlineTextArea };
export default InlineTextArea;
//# sourceMappingURL=index.js.map